module.exports = __webpack_public_path__ + "img/logo_big.3f0858e5.png";